/**
 * Persistent customer top bar (#2021).
 *
 * Three regions:
 *   ┌────────────────────┬──────────────────────────┬──────────────────────┐
 *   │  left slot (page)  │   GlobalSearch (always)  │   right slot (page)  │
 *   └────────────────────┴──────────────────────────┴──────────────────────┘
 *
 * All page chrome (profile, logout, docs, status, etc.) lives in the side
 * nav — the top bar deliberately doesn't duplicate it. Left and right slots
 * are owned by the page via `useTopBarSlots`. The middle is non-negotiable.
 *
 * Not used by editor layouts (no horizontal room) or by share/payment
 * wrappers (different chrome).
 */

import GlobalSearch from './navbar/global-search';
import { useTopBarContent } from './top-bar-context';

export default function TopBar() {
  const { left, right } = useTopBarContent();

  return (
    <div className="bg-app w-full h-12 md:h-16 mt-4 flex-shrink-0 flex items-center gap-3 px-4 md:px-6">
      {/* Left slot — page-specific (greeting, title, breadcrumb). Hidden on
          narrow viewports to give the search room. */}
      <div className="hidden md:flex items-center min-w-0 flex-shrink basis-0 flex-grow">
        {left}
      </div>

      {/* Center — global search. Fixed-width on desktop so it doesn't get
          squished by long left content. */}
      <div className="flex-1 md:flex-none md:w-[420px] flex justify-center">
        <GlobalSearch />
      </div>

      {/* Right slot — page-specific action buttons. Visible on mobile at
          natural width so page CTAs like "New user" are reachable; on
          desktop it grows to fill the remaining row. */}
      <div className="flex items-center gap-2 flex-shrink-0 md:basis-0 md:flex-grow md:justify-end">
        {right}
      </div>
    </div>
  );
}
